import { addId } from './utils/utils';

export enum FieldTypes {
  CHECKLIST = 'checklist',
  RADIO = 'radio',
}

export enum ToolType {
  POLYGON = 'polygon',
  RECTANGLE = 'rectangle',
  LINE = 'line',
  POINT = 'point',
}

export interface ClassificationField {
  id: string,
  name: string,
  instructions: string,
  type: FieldTypes,
  options: {
    value: string,
    label: string
  }[],
  userAnswer?: string[] | string;
}

export type Tool = {
  id: string;
  name: string;
  color: string;
  tool: ToolType;
  classifications?: ClassificationField[]
};

export interface Customization {
  tools: Tool[],
  classificationFields: ClassificationField[]
}

export const screenText: Customization = {
  tools: [
    {name: "Car", color: "navy", tool: "polygon"},
    {name: "Tree", color: "green", tool: "polygon"},
    {name: "Road Sign", color: "orange", tool: "polygon"},
    {name: "Person", color: "pink", tool: "rectangle"},
    {name: "Corner of Building", color: "red", tool: "point"}
  ].map(addId),
  classificationFields: [
    {
      "name": "model",
      "instructions": "Select the car model",
      "type": FieldTypes.RADIO,
      "options": [
        {
          "value": "model_s",
          "label": "Tesla Model S"
        },
        {
          "value": "model_3",
          "label": "Tesla Model 3"
        },
        {
          "value": "model_x",
          "label": "Tesla Model X"
        }
      ]
    },
    {
      "name": "image_problems",
      "instructions": "Select all that apply",
      "type": FieldTypes.CHECKLIST,
      "options": [
        {
          "value": "blur",
          "label": "Blurry"
        },
        {
          "value": "saturated",
          "label": "Over Saturated"
        },
        {
          "value": "pixelated",
          "label": "Pixelated"
        }
      ]
    }
  ].map(addId)
};



// WEBPACK FOOTER //
// ./src/customization.tsx